import { connect } from 'react-redux';

import UpdateServiceCodesModal from './UpdateServiceCodesModal';
import { updateQuickServiceCodes } from 'actions/quickSubs';
import { fetchQuickVendorServiceCodes } from 'actions/quickServiceCodes';
import { getQuickVendorServiceCodes, getQuickSubServiceCodes } from 'reducers';

const mapStateToProps = (state, { sub }) => ({
  serviceCodes: getQuickVendorServiceCodes(state, sub.vendor),
  subServiceCodes: getQuickSubServiceCodes(state, sub.id),
});

const mapDispatchToProps = {
  fetchServiceCodes: fetchQuickVendorServiceCodes,
  updateServiceCodes: updateQuickServiceCodes,
};

const UpdateQuickServiceCodesModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateServiceCodesModal);

export default UpdateQuickServiceCodesModal;
